import React from 'react';
import { Heart } from 'lucide-react';
import { useLanguage } from '../LanguageContext';

export const Welcome = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <section id="welcome" className="welcome-section">
        <div className="container">
          <div className="section-header">
            <Heart className="section-icon" />
            <h2 className="section-title">{t('welcome.title')}</h2>
            <div className="decorative-line-small"></div>
          </div>

          <div className="welcome-content" data-aos="fade-up">
            <p className="welcome-text">{t('welcome.message')}</p>
          </div>
        </div>
      </section>
      
      {/* Elegant separator */}
      <div className="section-separator">
        <div className="separator-line"></div>
        <div className="separator-ornament">
          <Heart className="separator-heart" fill="currentColor" />
        </div>
        <div className="separator-line"></div>
      </div>
    </>
  );
};

export default Welcome;
